// src/components/sections/Faqs.jsx
import React from "react";
import faqData from "../data/faqData";
import { useTranslation } from "react-i18next";

// ملاحظة: بدون UseScrollAnimation وبدون أي أنيميشن
export default function Faqs() {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      {faqData.map((el) => {
        const id = el.id ?? el.question;
        return (
          <details
            key={id}
            className="rounded-lg border border-gray-200 bg-white overflow-hidden"
          >
            <summary className="list-none cursor-pointer px-4 py-3 font-semibold flex items-center justify-between">
              <span className="text-sm md:text-base">{t(el.question)}</span>
              {/* سهم بسيط بدون دوران/انتقالات */}
              <span className="text-gray-500">▾</span>
            </summary>

            <div className="px-4 pb-3 pt-0">
              <p className="text-sm text-gray-700">{t(el.answer)}</p>
            </div>
          </details>
        );
      })}
    </div>
  );
}
